const toasterConfig = {
  position: 'top-right',
  reverseOrder: false,
  gutter: 12,
  containerClassName: '',
  containerStyle: {},
  toastOptions: {
    className: '',
    duration: 3000,
    style: {
      background: '#363636',
      color: '#fff',
      zIndex: 100000,
    },
    success: {
      duration: 3000,
      theme: {
        primary: 'green',
        secondary: 'black',
      },
    },
  },
} as const;

export { toasterConfig };
